module.exports = __webpack_public_path__ + "img/网站3-13.9a72acbc.jpg";